var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10H9.33333C9.33333 10.1768 9.40357 10.3464 9.5286 10.4714L10 10ZM10 18.6667C5.21353 18.6667 1.33333 14.7865 1.33333 10H0C0 15.5228 4.47715 20 10 20V18.6667ZM18.6667 10C18.6667 14.7865 14.7865 18.6667 10 18.6667V20C15.5228 20 20 15.5228 20 10H18.6667ZM10 1.33333C14.7865 1.33333 18.6667 5.21353 18.6667 10H20C20 4.47715 15.5228 0 10 0V1.33333ZM10 0C4.47715 0 0 4.47715 0 10H1.33333C1.33333 5.21353 5.21353 1.33333 10 1.33333V0ZM9.33333 4V10H10.6667V4H9.33333ZM9.5286 10.4714L13.5285 14.4715L14.4715 13.5285L10.4714 9.5286L9.5286 10.4714Z",
    fill: "#495e57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0c5342f29e8331978cc99fbd4cb896b1.svg";
export { ForwardRef as ReactComponent };